import { render, staticRenderFns } from "./SeminarRowBrochure.vue?vue&type=template&id=33480477&scoped=true&"
import script from "./SeminarRowBrochure.vue?vue&type=script&lang=js&"
export * from "./SeminarRowBrochure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33480477",
  null
  
)

export default component.exports